import { render, staticRenderFns } from "./ChatWidget.vue?vue&type=template&id=523952ec&scoped=true"
import script from "./ChatWidget.vue?vue&type=script&lang=js"
export * from "./ChatWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatWidget.vue?vue&type=style&index=0&id=523952ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523952ec",
  null
  
)

export default component.exports